// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"6af234ad","109":"49d6fe8d","190":"dab95b76","490":"9cef6b99","500":"ab00ef3b","613":"4020565a","659":"ce679785","906":"2a8be779","948":"a635b66c","969":"daed3506"}[chunkId] + ".chunk.js";
};